import { DropdownOption } from '@hawkins/components';
import { useContext } from 'react';
import { wrapIntoDropdownOption } from 'src/domains/calculators/utilities/wrapIntoDropdownOption';
import { CameraContext } from './CameraContext';
import { CameraSensorMode } from './types';

export const defaultCustomSensorMode: CameraSensorMode = {
  id: 'custom',
  cameraName: '',
  name: '',
  horizontal: null,
  vertical: null,
};

export const useSensorModeLookup = () => {
  const cameras = useContext(CameraContext);

  const sensorModeLookup = cameras.map((camera) => {
    const children = camera.models.map((cameraModel) => {
      const sensorModes = cameraModel.sensorModes;

      if (sensorModes.length === 0) {
        /**
         * There are actual valid real life use cases
         * where a camera might not have a sensor mode
         * but defer that to another device.
         *
         * In case the model doesn't have sensor modes, consider it a custom camera
         * so the UI can show the resolution values form to the end user.
         */
        return {
          label: cameraModel.name,
          value: defaultCustomSensorMode,
        };
      }

      const formattedCameraName = `${camera.name} ${cameraModel.name}`;

      const children = sensorModes.map((sensorMode) => {
        return wrapIntoDropdownOption(
          `${formattedCameraName} - ${sensorMode.name}`,
          { ...sensorMode, cameraName: formattedCameraName }
        );
      });

      return {
        label: cameraModel.name,
        children,
      };
    });

    return {
      label: camera.name,
      children,
    };
  });

  const customCamera: DropdownOption<CameraSensorMode> = {
    label: 'Custom',
    value: defaultCustomSensorMode,
  };

  return [...sensorModeLookup, customCamera];
};
